<div class="tag-item flipper"
  [ngClass]="{'verso': isVerso}"
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()">
  <div class="front-face"
    [ngClass]="{'disabled': !tag.enabled}"
    [style.color]="tag.included ? tag.fgColor : tag.bgColor"
    [style.backgroundColor]="tag.included ? tag.bgColor : tag.fgColor">
    <span [title]="tag.description | translate">
      {{ tag.fullTagName }}
    </span>
  </div>
  <div class="back-face"
    [style.color]="tag.fgColor"
    [style.backgroundColor]="tag.bgColor"
    [style.color]="getCheckColor(tag.bgColor)">
    @if (tag.withToolbox) {
      <i
        class="fal"
        [ngClass]="tag.included ? 'fa-search-plus' : 'fa-search-minus'"
        [title]="'CMDB.TAGS.FILTER.TOOLBAR.' + (tag.included ? 'EXCLUDE': 'INCLUDE') | translate"
        aria-hidden="true"
        (click)="onToggleIncluded()">
      </i>
    }
    @if (tag.withToolbox) {
      <i
        class="fal "
        [ngClass]="tag.enabled ? 'fa-check-square' : 'fa-square'"
        [title]="'CMDB.TAGS.FILTER.TOOLBAR.' + (tag.enabled ? 'DISABLE': 'ENABLE') | translate"
        aria-hidden="true"
        (click)="onToggleEnabled()">
      </i>
    }
    <i class="fal fa-trash"
      aria-hidden="true"
      (click)="onUnselect()">
    </i>
  </div>
</div>
